import {Box, IconButton, Modal} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import useId from 'modules/reports/hooks/id'
import useModal from 'modules/reports/hooks/modal'
import React, {useState} from 'react'
import ReportsModalContext, {ReportsModalContextProps} from './ReportsModal.context'
import useStyles from './ReportsModal.styles'
import usePrefix from 'modules/reports/hooks/prefix'

type Props = {
  children: React.ReactNode
  height?: string | number
  'data-testid': string
}

function ReportsModal(props: Props) {
  const [extended, setExtended] = useState(false)
  const modal = useModal()

  const classes = useStyles({extended})
  const id = useId()
  const p = usePrefix(props['data-testid'])

  const contextValue: ReportsModalContextProps = {id, prefix: p(), extended, setExtended}

  function handleClose() {
    modal.close()
  }

  return (
    <Modal open={true} aria-labelledby={`${id}-title`} onClose={handleClose} data-testid={p()}>
      <ReportsModalContext.Provider value={contextValue}>
        <Box className={classes.paper} height={props.height}>
          <IconButton className={classes.close} onClick={handleClose} data-testid={p('close')}>
            <CloseIcon />
          </IconButton>

          {props.children}
        </Box>
      </ReportsModalContext.Provider>
    </Modal>
  )
}

export default ReportsModal
